import React from "react";
import democracy from "../../assets/images/democracy.png";
import Ecological from "../../assets/images/Ecological.png";
import Nonviolence from "../../assets/images/Nonviolence.png";
import Sustainability from "../../assets/images/Sustainability.png";
import Respect from "../../assets/images/Respect.png";
import Justice from "../../assets/images/Justice.png";
import { Fade } from "react-reveal";
const Princibles = () => {
  return (
    <div className="flex flex-col justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
      <p className="font-['FuturaExtraBold'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-[#00693A]">
        <Fade top>PRINCIPLES</Fade>
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-12 sm:gap-16 md:gap-20 lg:gap-28 xl:gap-12 2xl:gap-16 mt-12 md:space-y-5 lg:space-y-8 ">
        <Fade left cascade>
          <div className="flex flex-col justify-end items-center">
            <img src={Ecological} alt={""} className="h-[90px]" />
            <p className=" text-sm sm:text-sm md:text-md lg:text-lg xl:text-xl py-1">
              Ecological wisdom
            </p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Nonviolence} alt={""} className="h-[90px]" />
            <p className=" text-sm sm:text-sm md:text-md lg:text-lg xl:text-xl py-1">
              Nonviolence
            </p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Sustainability} alt={""} className="h-[90px]" />
            <p className=" text-sm sm:text-sm md:text-md lg:text-lg xl:text-xl py-1">
              Sustainability
            </p>
          </div>
        </Fade>
        <Fade right cascade>
          <div className="flex flex-col justify-end items-center">
            <img src={democracy} alt={""} className="h-[90px]" />
            <p className=" text-sm sm:text-sm md:text-md lg:text-lg xl:text-xl py-1">
              Participatory democracy
            </p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Respect} alt={""} className="h-[90px]" />
            <p className=" text-sm sm:text-sm md:text-md lg:text-lg xl:text-xl py-1">
              Respect for diversity
            </p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Justice} alt={""} className="h-[90px]" />
            <p className=" text-sm sm:text-sm md:text-md lg:text-lg xl:text-xl py-1">
              Social Justice
            </p>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Princibles;
